const trackEventIgnoreWidgetNames = ['DR_finance_standalone'];
const trackEventIgnoreEventNames = [
	'Web: VDP > Inventory Detail Pricing Box > SMS Share Form > Clicked Submit Button'
];

const handleTrackEvent = async ({ DDC }, _event, eventData, additionalData) => {
	let eventObject;
	const {
		dataLayer,
		dataLayer: { events }
	} = DDC;
	if (eventData) {
		const { eventName, widgetName } = eventData;
		if (
			eventName &&
			widgetName &&
			!trackEventIgnoreWidgetNames.includes(widgetName) &&
			!trackEventIgnoreEventNames.includes(eventName)
		) {
			const { data } = eventData;
			if (additionalData) {
				dataLayer.confirmation = dataLayer.confirmation || {};

				// Check for element in the additionalData and use that if it exists
				// This preserves legacy behavior where a DOM element is expected in additionalData and not an object
				dataLayer.confirmation.element =
					additionalData?.element || additionalData;
			}

			if (
				eventName.toLowerCase().includes('submit') &&
				widgetName !== 'facetmulti' &&
				widgetName !== 'digital-retailing-cox'
			) {
				eventObject = await events.form.confirmation(
					undefined,
					widgetName
				);
			} else if (eventName.toLowerCase().includes('confirm')) {
				// protection-driver 'confirm' events are not actually form confirms so we need special-case handling around that widget
				if (widgetName.includes('protect')) {
					eventObject = await events.form.confirmation(
						undefined,
						data
					);
				} else {
					eventObject = await events.form.confirmation(
						undefined,
						widgetName
					);
				}
			} else if (widgetName.includes('KBB')) {
				if (
					data === 'submit_calculate_trade_integrated' ||
					data === 'send_update_calculate_trade_integrated'
				) {
					eventObject = await events.form.confirmation(
						undefined,
						widgetName
					);
				}
			} else if (widgetName.includes('recommended_vehicles')) {
				if (
					(DDC.client.isDesktop && data === 'list_clicked') ||
					(DDC.client.isMobile && data === 'list_hovered')
				) {
					// Fires clicked event handler on recommended_vehicles widget list_clicked trackEvent.
					eventObject = events.link.recommendedVehicle(eventData);
				}
			} else if (
				typeof data === 'string' &&
				data.includes('Submitted Instant ePrice')
			) {
				eventObject = await events.form.confirmation(undefined, data);
			}
		}
	}
	return eventObject;
};

export default handleTrackEvent;
